import { render, staticRenderFns } from "./grapichpenduduk.vue?vue&type=template&id=02be468c"
import script from "./grapichpenduduk.vue?vue&type=script&lang=js"
export * from "./grapichpenduduk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports